<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-season-tickets', params: {id: accountId}}">
              {{ $t('accountSeasonTickets.detailsView.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ accountSeasonTicketId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('accountSeasonTickets.detailsView.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="details">
              <account-season-ticket-details :details="details"/>
              <div class="row mt-3" v-if="$auth.can({account_season_tickets: 'update'}, 'permissions')">
                <div class="col-6">
                  <div class="row">
                    <div class="col-6">
                      <account-season-ticket-cancel-btn :disabled="details.status !== 'verified'" :id="details.id"
                                                        :account-id="accountId"/>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import AccountSeasonTicketDetails from 'src/components/AccountSeasonTicket/AccountSeasonTicketDetails'
import AccountSeasonTicketCancelBtn from './AccountSeasonTicketCancelBtn'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountSeasonTicket",
  components: {
    AccountSeasonTicketDetails,
    AccountSeasonTicketCancelBtn
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    accountSeasonTicketId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountSeasonTicket']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountSeasonTicket({accountID: this.accountId, ID: this.accountSeasonTicketId});
  },
  computed: {
    ...mapState({
      // darkTheme: state => state.app.darkMode,
      loading: state => state.account_season_ticket.loading,
      details: state => state.account_season_ticket.data,
    }),
  },
}
</script>

